import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';

const HELPS_IN = [
  {
    id: 1,
    title: 'Shared access',
    description: 'Allow teammates to view and manage air quality data.',
    image: '/images/onboarding/help-1.png'
  },
  {
    id: 2,
    title: 'Role-based control',
    description: 'Assign permissions for better security.',
    image: '/images/onboarding/help-2.png'
  },
  {
    id: 3,
    title: 'Real-time collaboration',
    description: 'Keep everyone informed with live data updates.',
    image: '/images/onboarding/help-3.png'
  }
];

/**
 * Header component.
 * @returns - React element that represents the Header component.
 */
function Header(): ReactElement {
  return (
    <div className="flex flex-col items-center">
      <div className="text-white text-2xl font-bold">
        <span className="text-primary-500">Step 5:</span> Invite users
      </div>
      <div className="text-gray-400 mt-1">Invite users to your account</div>
    </div>
  );
}

/**
 * AddDevice component.
 * @returns - React element that represents the AddDevice component.
 */
export default function OnboardingInviteUsers(): ReactElement {
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);

  if (clicked) {
    return (
      <div className="flex flex-col flex-1  items-center">
        <Header />
        <button
          type="button"
          className="material-icons-outlined text-md cursor-pointer absolute top-0 left-0 text-white"
          onClick={() => navigate(-1)}
        >
          chevron_left
        </button>
        <div className="mt-5 flex flex-1 max-h-[40.813rem] flex-col rounded bg-container-500 w-[66.66vw]">
          <div className="flex items-center justify-between h-fit p-4 w-full bg-container-700 border-b border-gray-900">
            <div className="text-sm text-gray-600" />
            <div className="flex gap-2">
              <Button name="Invite users" theme="secondary-gray" size="sm" />
            </div>
          </div>
          <div className="max-h-full overflow-y-auto">
            <table className="w-full border-collapse">
              <thead className="bg-container-700 font-medium text-gray-400 text-xs sticky top-0">
                <tr>
                  <th className="h-11 text-center border-t border-b border-gray-900 w-1/3">Name</th>
                  <th className="h-11 text-center border-t border-b border-gray-900 w-1/3">
                    Email
                  </th>
                  <th className="h-11 text-center border-t border-b border-gray-900 w-1/3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-300 font-medium text-sm">
                <tr>
                  <td className="h-20 text-center border-b border-gray-900">John Doe</td>
                  <td className="h-20 text-center border-b border-gray-900">
                    john.doe@example.com
                  </td>
                  <td className="h-20 text-center border-b border-gray-900">
                    <Button name="Remove" theme="secondary-color" size="sm" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="my-6 flex gap-2">
          <Button
            onClick={() => {
              navigate('/', { replace: true });
            }}
            name="Go to dashboard"
            theme="primary"
            size="sm"
          />
        </div>
      </div>
    );
  }
  return (
    <div className="flex flex-col flex-1 items-center justify-between w-full relative">
      {' '}
      <button
        type="button"
        className="material-icons-outlined text-md cursor-pointer absolute top-0 left-0 text-white"
        onClick={() => navigate(-1)}
      >
        chevron_left
      </button>
      <Header />
      <div>
        <div className="mt-12 gap-5 flex justify-center items-center">
          {HELPS_IN.map((help) => (
            <div key={help.id} className="flex flex-col items-center  h-full w-[17.688rem]">
              <div className="w-[9.25rem] h-[9.25rem] rounded-lg bg-container-300" />
              <div>
                <div className="text-white text-xl font-semibold mt-4 text-center">
                  {help.title}
                </div>
                <div className="text-gray-400 mt-1 text-center">{help.description}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-center mt-16">
          <Button
            onClick={() => {
              setClicked(true);
            }}
            name="Invite users"
            theme="primary"
            size="sm"
          />
        </div>
      </div>
      <div className="flex gap-2">
        <Button
          onClick={() => {
            setClicked(true);
          }}
          name="Skip & go to dashboard"
          theme="secondary-color"
          size="sm"
        />
      </div>
    </div>
  );
}
